// extracted by mini-css-extract-plugin
export default {"generalContent":"Selo_generalContent__fLhFo","tituloSelo":"Selo_tituloSelo__fSfnB","textoSelo":"Selo_textoSelo__Vjdfl","linkSelo":"Selo_linkSelo__fiBGC","selo":"Selo_selo__F4vW4"};